var React = require('react');

function YoutubeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M21.899 5.195c.662.688.877 2.256.877 2.256l-.002-.002a35.93 35.93 0 0 1 .224 3.681v1.732c-.01 1.23-.082 2.46-.218 3.682 0 0-.215 1.569-.876 2.257-.755.816-1.59.9-2.064.949l-.141.015C16.624 20 12 20 12 20s-5.72-.052-7.48-.226a4.873 4.873 0 0 0-.304-.044c-.56-.07-1.432-.178-2.126-.929-.657-.697-.872-2.264-.872-2.264A35.861 35.861 0 0 1 1 12.854v-1.723c.01-1.23.082-2.46.218-3.681 0 0 .212-1.568.878-2.256.754-.816 1.588-.9 2.06-.948.053-.006.1-.01.144-.016C7.38 4 11.998 4 11.998 4s4.621 0 7.697.231c.043.006.09.01.142.016.472.048 1.309.133 2.062.948ZM17 12 9 8v8l8-4Z","clipRule":"evenodd"}));
}

YoutubeInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","role":"img","aria-label":"YouTube"};

module.exports = YoutubeInline;

YoutubeInline.default = YoutubeInline;
